import { css, styled, spacing, Text } from '@thg-commerce/enterprise-theme'

export const LiveChatWrapper = styled.div`
  display: none;
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);

  .LPMcontainer.LPMoverlay {
    display: none !important;
  }
`

export const Container = styled.div`
  margin: ${spacing(4)} 0;
  border: solid 1px ${(props) => props.theme.colors.palette.greys.light};
  width: 100%;
`

const PaddingAttribute = css`
  padding: ${spacing(2)} ${spacing(2)};
`

export const TopContainer = styled.div`
  ${PaddingAttribute}
  background-color: #eee;
  display: flex;
  flex-direction: row;
`

export const BottomContainer = styled.div`
  ${PaddingAttribute}
`

export const SubtitleLine = styled.p`
  ${Text('medium1', 'alternate')};

  margin-bottom: ${spacing(0.5)};
`

export const ActiveSearchText = styled.p`
  ${Text('bodyText', 'default')};

  margin-bottom: ${spacing(2)};
`

export const IconContainer = styled.div`
  margin-right: ${spacing(2)};
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
`
export const ChatIcon = styled.div`
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.theme.site.favicon});
`

export const OnlineText = styled.p`
  color: #007831;
  margin-top: ${spacing(-0.55)};
  margin-left: ${spacing(0.5)};
`

export const OnlineTextContainer = styled.div`
  display: flex;
`

export const ChatTextContainer = styled.div`
  display: flex;
  align-items: center;
`
